import { isHotkeyToOpenWidget } from '@uw/common-components/src/utils/widget-hotkeys';
import { getConfig } from './userway';
import { useLocalStorage } from '../core/use-local-storage';

export interface ExpandableInfoPanelProps {
  storageKey: string;
  actionElement: HTMLButtonElement;
  onToggle: (isVisible: boolean | null) => void;
}

export function expandablePanel({
  actionElement,
  onToggle,
  storageKey,
}: ExpandableInfoPanelProps) {
  const [getVisibility, setVisibility] = useLocalStorage<boolean>(storageKey);
  const toggleVisibility = () => {
    const isVisible = getVisibility();
    if (!isVisible) {
      window.postMessage(
        {
          isUserWay: true,
          action: 'sendEventToGoogleAnalytics',
          name: 'userway_widget_open',
        },
        '*',
      );
    }
    setVisibility(!isVisible);
    updateVisibility();
  };
  const config = getConfig();
  const updateVisibility = () => {
    const isVisible = getVisibility();
    onToggle(isVisible);
  };

  actionElement.addEventListener('click', () => toggleVisibility());

  window.addEventListener(
    'keydown',
    (event) => {
      if (isHotkeyToOpenWidget(config, event)) {
        // CTRL + U - default
        event.preventDefault();
        toggleVisibility();
      }
    },
    true,
  );

  updateVisibility();
}
